import React from "react";
import { FiChevronDown, FiList } from "react-icons/fi";

import styles from "./new.module.css";
import { getSentenceFromCamelCase } from "./Helpers";
import { SelectProps } from "../../types/form";

type ModernSelectProps = SelectProps & {
  leftIcon?: React.ReactNode;
};

const Select = ({
  className,
  disabled,
  error,
  required,
  label,
  name,
  onChange,
  style,
  data,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  filter,
  filterValue,
  title,
  leftIcon,
}: ModernSelectProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;

    onChange && onChange(name, value);
  };

  const onValidationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!validationHandler) return;

    const { value } = event.target;
    let errorMessage = "";

    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    }

    validationHandler(name, errorMessage);
  };

  return (
    <div
      className={`${styles.InputContainer} ${styles[size || ""]} ${
        error ? styles.hasError : ""
      }`}
    >
      <label htmlFor={name} className={labelClassName || styles.inputLabel}>
        {label} {required && <span className={styles.required}>&nbsp;*</span>}
      </label>

      <div className={styles.fieldShell}>
        <span className={styles.fieldIcon} aria-hidden="true">
          {leftIcon || <FiList />}
        </span>

        <select
          id={name}
          value={value as string}
          required={required}
          name={name}
          className={`${styles.blackBorder} ${styles.modernInput} ${
            styles.modernSelect
          } ${className || ""} ${error ? styles.borderRed : ""}`}
          style={style}
          disabled={disabled}
          onChange={onChangeHandler}
          onBlur={onValidationChange}
        >
          <option value="">{title || label || "Select option"}</option>

          {data &&
            data.map((item: any, i: number) =>
              filter ? (
                <option value={item[filterValue || ""]} key={i}>
                  {item[filter]}
                </option>
              ) : (
                <option value={item.value} key={i}>
                  {item.label || item.value}
                </option>
              ),
            )}
        </select>

        <span className={styles.selectIcon} aria-hidden="true">
          <FiChevronDown />
        </span>
      </div>

      {error ? (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default Select;
